"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardSelectionErrorCode = void 0;
/**
 * The Rewards Card cash-back selection contract: which boost reward a customer chooses, and the shapes that
 * cross the wire when they choose it.
 * The choice *is* an `AvenBoostRewardsName` which the enrollment row stores and the rewards
 * engine grants (`aven_types/src/origination/avenBoostRewards.ts`).
 */
/**
 * The codes this surface can return to a client. They are part of the wire contract, so the frontend can
 * branch on them by name rather than by a string that can drift from the backend's.
 */
var RewardSelectionErrorCode;
(function (RewardSelectionErrorCode) {
    RewardSelectionErrorCode["notEligible"] = "REWARD_SELECTION_NOT_ELIGIBLE";
    RewardSelectionErrorCode["notSelectable"] = "REWARD_SELECTION_NOT_SELECTABLE";
})(RewardSelectionErrorCode || (exports.RewardSelectionErrorCode = RewardSelectionErrorCode = {}));
